'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormPrimaryMessage = require('./FormPrimaryMessage');

var _FormPrimaryMessage2 = _interopRequireDefault(_FormPrimaryMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimarySuccessMessage = function PrimarySuccessMessage(_ref) {
    var message = _ref.message,
        show = _ref.show,
        children = _ref.children;
    return _react2.default.createElement(
        _FormPrimaryMessage2.default,
        { className: 'PrimarySuccessMessage', message: message, show: show, icon: 'green-tick' },
        children
    );
};

// Components
// Lib


PrimarySuccessMessage.propTypes = {
    message: _propTypes2.default.string.isRequired,
    show: _propTypes2.default.bool,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = PrimarySuccessMessage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/messages/PrimarySuccessMessage.js
// module id = 1782
// module chunks = 0